/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "materialDashboard/theme/base/colors";

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      //display: "grid",  // removed because because prevent input to hide overflow text
      alignItems: "center",
      // padding: `0 ${pxToRem(12)} !important`, // removed

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      // display: "none", // reveomed
      width: "1.75em",
      height: "1.75em",
      top: "calc(50% - 1em)",
    },
  },
};

export default select;
